import {camelCase} from 'lodash';

export const toQueryString = data =>
  Object
    .keys(data)
    .map(key => [camelCase(key), data[key]].map(encodeURIComponent).join('='))
    .join('&');

export default toQueryString;
